import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {Message} from 'primeng/api';
import {GrowlType} from "@app/shared";

@Injectable()
export class GrowlService {
  private msgs = new Subject<Message>();
  public added = this.msgs.asObservable();

  public add(type: string | GrowlType, msg: string, connect?: boolean, req?: any) {
    let summary: string;
    let newMsg: Message = {severity: type, detail: msg};

    switch (type) {
      case GrowlType.Info: {
        if (connect) {
          summary = 'Connect';
        } else {
          summary = 'Information:';
        }
        break;
      }
      case GrowlType.Success: {
        summary = 'Success:';
        break;
      }
      case GrowlType.SuccessLong: {
        summary = 'Success:';
        break;
      }
      case GrowlType.Warn: {
        summary = 'Warning:';
        break;
      }
      case GrowlType.Error: {
        summary = 'Error: Please retry or contact Support';
        break;
      }
    }
    newMsg['summary'] = summary;
    this.msgs.next(newMsg);
  }
}
